module.exports = __webpack_public_path__ + "img/programme8.9ee05841.png";